/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_L1_Point_1_TextInputs */

const en_visa_l1_point_1_text = /** @type {(inputs: Visa_L1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The role abroad, the intended U.S. role, and the employee's history with the company are all reviewed together rather than by title alone.`)
};

const pt_visa_l1_point_1_text = /** @type {(inputs: Visa_L1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A função no exterior, a função pretendida nos EUA e o histórico do funcionário com a empresa são todos revisados em conjunto, e não apenas pelo cargo.`)
};

const es_visa_l1_point_1_text = /** @type {(inputs: Visa_L1_Point_1_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El cargo en el extranjero, el cargo previsto en EE. UU. y el historial del empleado con la empresa se revisan en conjunto, no solo por el título del cargo.`)
};

/**
* | output |
* | --- |
* | "The role abroad, the intended U.S. role, and the employee's history with the company are all reviewed together rather than by title alone." |
*
* @param {Visa_L1_Point_1_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_l1_point_1_text = /** @type {((inputs?: Visa_L1_Point_1_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_L1_Point_1_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_l1_point_1_text(inputs)
	if (locale === "es") return es_visa_l1_point_1_text(inputs)
	return en_visa_l1_point_1_text(inputs)
});